import * as React from 'react';
import { Link, MenuItem, Divider } from '@mui/material';
import { NavLink } from '../../model';
import ListSubheader from '@mui/material/ListSubheader';

export const MoreMenuItem = ({ menuLink, onClick }: { menuLink: NavLink, onClick: () => void }) => {
    if (menuLink.separator) {
        return <Divider />;
    }
    if (!menuLink.path) {
        return <ListSubheader>{menuLink.text}</ListSubheader>;
    }

    return (
        <MenuItem component={Link} href={menuLink.path} onClick={onClick}>
            {menuLink.text}
        </MenuItem>
    );
};
